import React from 'react';
import { Box } from '@mui/material';
import { Navigate, Outlet } from 'react-router-dom';
import {
	ResponsiveAppBar,
	ResponsiveDrawer
} from 'components';
import { useAuth } from 'hooks';
import { CoreRoutes } from 'app-constants';

const drawerWidth = 240;

// Protected Route Props Interface
interface ProtectedRouteProps {
	children: React.ReactNode;
}

// Protected Route Component
const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
	const { isAuth } = useAuth();
	return isAuth ? <>{children}</> : <Navigate to={CoreRoutes.login} replace />;
};
const processRouteToTitle = (route: string): string => {
	return `Business Excellence ${route !== CoreRoutes.home
		? ' - ' +
		route
			.replace('/', '')
			.replace('-', ' ')
			.split(' ')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ')
		: ''
		}`;
};
export const PageLayout = () => {
	return (
		<>
			<Box minHeight='calc(100vh - 64px)' mt={'20px'}>
				<ProtectedRoute>
					<Box sx={{ display: 'flex', height: 'calc(100vh -20px)' }}>
						<ResponsiveAppBar drawerWidth={drawerWidth} title={processRouteToTitle(window.location.pathname)} />
						<ResponsiveDrawer drawerWidth={drawerWidth} userIsAdministrator={true} />
						<Box
							component='main'
							sx={{
								flexGrow: 1,
								width: { sm: `calc(100% - ${drawerWidth}px)` },
								mt: 'calc(48px + 0.5rem)',
							}}
						>
							<Outlet />
						</Box>
					</Box>
				</ProtectedRoute >
			</Box >
		</>
	);
};
